/* Maps a Receipt.matchState (UNMATCHED / MATCHED / DUPLICATE) to a labelled Nomad Badge. */
import { Badge, type BadgeProps } from '@andavo/web-ui';
import type { ReceiptMatchState } from './hooks/use-receipts';

const CONFIG: Record<
  ReceiptMatchState,
  { label: string; variant: NonNullable<BadgeProps['variant']> }
> = {
  UNMATCHED: { label: 'Unmatched', variant: 'warning' },
  MATCHED: { label: 'Matched', variant: 'success' },
  DUPLICATE: { label: 'Duplicate', variant: 'default' },
};

export function ReceiptBadge({ state }: { state: ReceiptMatchState }) {
  const { label, variant } = CONFIG[state];
  return (
    <Badge variant={variant} intent="background" borderRadius="round">
      {label}
    </Badge>
  );
}
